import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FullscreenExitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fullscreen_exit"}/>
}
